module.exports = __webpack_public_path__ + "static/media/certificate4.db508e26.webp";